import { useLocalStorage } from 'react-use';
import { useCallback } from 'react';

import { type AutoSuggestOption } from '../components/AutoComplete/AutoComplete';

const RECENT_SEARCHES_STORAGE_KEY = 'recent-searches';
const RECENT_SEARCHES_STORAGE_MAX_LENGTH = 500;

export const useRecentSearchStorage = () => {
  const [recentSearches, setRecentSearches] = useLocalStorage<AutoSuggestOption[]>(RECENT_SEARCHES_STORAGE_KEY, []);

  const saveToRecentSearches = useCallback(
    (search: AutoSuggestOption) => {
      const filteredSearches = recentSearches?.filter((s) => s.id !== search.id) ?? [];
      const newSearches = [{ ...search, isRecentSearch: true }, ...filteredSearches];
      setRecentSearches(newSearches.slice(0, RECENT_SEARCHES_STORAGE_MAX_LENGTH));
    },
    [recentSearches, setRecentSearches],
  );

  const searchByTitle = useCallback(
    (query: string): AutoSuggestOption[] => {
      // Reason: query can be a non-string at runtime when placeName from the URL was coerced
      // by qs.parse (parseNumbers/parseBooleans), e.g. postal codes like "20354".
      const normalizedQuery = query == null ? '' : String(query);
      if (!normalizedQuery) return recentSearches || [];

      const searchTerm = normalizedQuery.toLowerCase();
      return (recentSearches || []).filter((search) => typeof search.title === 'string' && search.title.toLowerCase().includes(searchTerm));
    },
    [recentSearches],
  );

  return {
    recentSearches: recentSearches || [],
    saveToRecentSearches,
    searchByTitle,
  };
};
